import {format, parseISO} from 'date-fns';
import NextLink from 'next/link';

import {Button, Modal, Text} from '#component/base';
import {ModalClose} from '#component/base/Modal';
import {sprinkles} from '#style/sprinkles';
import {getFormattedDateRange} from '#util';

import {CheckInExitModalProps} from './CheckInExitModal.types';

/**
 * `CheckInExitModal` renders a prompt to confirm that the user wants to leave
 * the Check in page without completing their current check-in.
 */
export const CheckInExitModal = ({endedOn = '', startedOn = ''}: CheckInExitModalProps) => (
  <Modal
    header={
      <Text
        className={sprinkles({height: 'full', flex: 'flex', items: 'center'})}
        color="deepBurgundy"
        variant="heading4">
        {getFormattedDateRange(startedOn, endedOn)}
      </Text>
    }
    footer={
      <div className={sprinkles({dir: ['colReverse', 'row'], flex: 'flex', gap: 8, w: 'full'})}>
        <NextLink href="/dashboard" passHref>
          <Button as="a" variant="secondary">
            Yes, I want to exit
          </Button>
        </NextLink>

        <Button as={ModalClose}>Nevermind</Button>
      </div>
    }
    layout="drawer">
    <div className={sprinkles({dir: 'col', flex: 'flex', gap: 16})}>
      <Text as="h1" className={sprinkles({pR: [24, 80, 0]})} color="burgundy" variant="heading2">
        Are you sure you want to exit?
      </Text>

      <Text as="p">
        Your information will not be saved. You may access this week’s check-in flow via your
        notification link or your Action Plan anytime
        <Text fontWeight="semiBold">{` on or before ${
          endedOn ? format(parseISO(endedOn), 'MMM d, yyyy') : 'the end of the check-in period'
        }`}</Text>
      </Text>
    </div>
  </Modal>
);
